/**
 * Error handling methods
 */
import { configSentryError } from "./sentry";
import { useAlert } from "@esenda/core-ui/composables";

const { showAlert } = useAlert();

export const handleQueryParamsError = (
    queryObject: any,
    missingParam: string,
) => {
    /**
     * Logs missing query param error to Sentry and shows an alert to the user.
     * @param {[any]} queryObject
     * @param {[string]} missingParam
     * @returns {[void]}
     */
    configSentryError(
        "OneTimeLink",
        "handleOneTimeLinkLogic",
        `Missing required route/query parameter ${missingParam}. The provided link parameters are ${JSON.stringify(
            queryObject,
            null,
            2,
        )}`,
    );
    showAlert("alerts.unexpectedErrorWithRefreshAction");
};
